import { ContractTableDTO } from '../../../../../Domain/DTO/ContractTableDTO';

export class SelectContractHelperProps{
    ContractList: Array<ContractTableDTO>
    SelectedContract: ContractTableDTO
}

export const InitialSelectContractHelperProps: SelectContractHelperProps = <SelectContractHelperProps>{ 
    ContractList: []
};